const routeNames = {
  LANDING: "/",
  SUCCESS: "/success",
  SCAN: "/scan/:id",
  NOT_WINNER: "/no-win",
  ALREADY_ENTERED: "/already-entered",
  OUT_HOURS: "/out-of-hours",
  PRE_ENTRY: "/pre-entry",
  CLOSED: "/closed",
  TERMS: "/terms",
  PRIVACY: "/privacy-policy",
  WINNER: "/winner",
  CONFIRMATION: "/confirmation",
  PRIZES: "/prizes",
  LOCATIONS: "/locations",
};

export default routeNames;
